export const DOM_KEY_REPORT_SETTING_TIME_FRAME = 'time-frame';
export const DOM_KEY_REPORT_SETTING_WEIGHTING_MODE = 'weighting-mode';
export const DOM_KEY_REPORT_SETTING_GRANULARITY = 'granularity';
export const DOM_KEY_REPORT_SETTING_TIME_ZONE = 'time-zone';
export const DOM_KEY_REPORT_SETTING_SAMPLE_FACTOR = 'sample-factor';
